"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6702],{

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(';')
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var index = pair.indexOf('=')

    // skip things that don't look like key=value
    if (index < 0) {
      continue;
    }

    var key = pair.substring(0, index).trim()

    // only assign once
    if (undefined == obj[key]) {
      var val = pair.substring(index + 1, pair.length).trim()

      // quoted values
      if (val[0] === '"') {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 47041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkCookies = exports.removeCookies = exports.setCookies = exports.getCookie = exports.getCookies = void 0;
var cookie_1 = __webpack_require__(76489);
var isClientSide = function () { return typeof window !== 'undefined'; };
var processValue = function (value) {
    if (value === 'true')
        return true;
    if (value === 'false')
        return false;
    if (value === 'undefined')
        return undefined;
    if (value === 'null')
        return null;
    return value;
};
var stringify = function (value) {
    if (value === void 0) { value = ''; }
    try {
        var result = JSON.stringify(value);
        return (/^[\{\[]/.test(result)) ? result : value;
    }
    catch (e) {
        return value;
    }
};
var decode = function (str) {
    if (!str)
        return str;
    return str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
};
var getCookies = function (options) {
    var req;
    if (options)
        req = options.req;
    if (!isClientSide()) {
        // if cookie-parser is used in project get cookies from ctx.req.cookies
        // if cookie-parser isn't used in project get cookies from ctx.req.headers.cookie
        if (req && req.cookies)
            return req.cookies;
        if (req && req.headers && req.headers.cookie)
            return (0, cookie_1.parse)(req.headers.cookie);
        return {};
    }
    var _cookies = {};
    var documentCookies = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < documentCookies.length; i++) {
        var cookieParts = documentCookies[i].split('=');
        var _cookie = cookieParts.slice(1).join('=');
        var name_1 = cookieParts[0];
        _cookies[name_1] = _cookie;
    }
    return _cookies;
};
exports.getCookies = getCookies;
var getCookie = function (key, options) {
    var _cookies = (0, exports.getCookies)(options);
    return processValue(decode(_cookies[key]));
};
exports.getCookie = getCookie;
var setCookies = function (key, data, options) {
    var _cookieOptions;
    var _req;
    var _res;
    if (options) {
        var req = options.req, res = options.res, _options = __rest(options, ["req", "res"]);
        _req = req;
        _res = res;
        _cookieOptions = _options;
    }
    var cookieStr = (0, cookie_1.serialize)(key, stringify(data), __assign({ path: '/' }, _cookieOptions));
    if (!isClientSide()) {
        if (_res && _req) {
            var currentCookies = _res.getHeader('Set-Cookie');
            _res.setHeader('Set-Cookie', 
            // @ts-ignore
            !currentCookies ? [cookieStr] : currentCookies.concat(cookieStr));
            if (_req && _req.cookies) {
                var _cookies = _req.cookies;
                data === '' ? delete _cookies[key] : _cookies[key] = stringify(data);
            }
            if (_req && _req.headers && _req.headers.cookie) {
                var _cookies = (0, cookie_1.parse)(_req.headers.cookie);
                data === '' ? delete _cookies[key] : _cookies[key] = stringify(data);
                _req.headers.cookie = Object.entries(_cookies).reduce(function (accum, item) {
                    return accum.concat(item[0] + "=" + item[1] + ";");
                }, '');
            }
        }
    }
    else {
        document.cookie = cookieStr;
    }
};
exports.setCookies = setCookies;
var removeCookies = function (key, options) {
    return (0, exports.setCookies)(key, '', __assign(__assign({}, options), { maxAge: -1 }));
};
exports.removeCookies = removeCookies;
var checkCookies = function (key, options) {
    if (!key)
        return false;
    var cookie = (0, exports.getCookies)(options);
    return cookie.hasOwnProperty(key);
};
exports.checkCookies = checkCookies;


/***/ }),

/***/ 97169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Dz": function() { return /* binding */ BelowTheFoldContent; },
  "Ks": function() { return /* binding */ RelatedResources; },
  "NV": function() { return /* binding */ SingleResourceArticle; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./node_modules/ilenia/dist/useTranslations.js
var useTranslations = __webpack_require__(53333);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Icons.js
var Icons = __webpack_require__(40815);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Links/index.js + 1 modules
var Links = __webpack_require__(17221);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/tracking.js
var tracking = __webpack_require__(14364);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Headers/index.js
var Headers = __webpack_require__(1723);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/constants/index.js
var constants = __webpack_require__(99043);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./node_modules/@trustpilot/businesssite-components/components/Author/index.js






var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__Wrapper",
  componentId: "sc-1ep02bo-0"
})(["padding:18px 0 28px 0;"]);
var Image = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__Image",
  componentId: "sc-1ep02bo-1"
})(["display:flex;flex-direction:column;justify-content:center;width:60px;height:60px;overflow:hidden;margin:0 20px 0 0;border-radius:50%;img{width:100%;height:auto;}"]);
var textMixin = "\n  font-size: ".concat(constants/* TEXT_XS */.ni, "rem;\n  line-height: ").concat(constants/* TEXT_LG */.E6, "rem;\n");
var SectionName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__SectionName",
  componentId: "sc-1ep02bo-2"
})(["margin-bottom:14px;font-weight:bold;", ""], textMixin);
var Header = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__Header",
  componentId: "sc-1ep02bo-3"
})(["display:flex;margin-bottom:14px;"]);
var Name = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__Name",
  componentId: "sc-1ep02bo-4"
})(["font-weight:bold;", ""], textMixin);
var Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__Title",
  componentId: "sc-1ep02bo-5"
})(["", " opacity:0.6;"], textMixin);
var Description = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__Description",
  componentId: "sc-1ep02bo-6"
})(["max-width:560px;text-align:left;", " opacity:0.6;"], textMixin);
var Info = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Author__Info",
  componentId: "sc-1ep02bo-7"
})(["display:flex;flex-direction:column;justify-content:center;"]);
var Author = function Author(_ref) {
  var image = _ref.image,
      name = _ref.name,
      title = _ref.title,
      description = _ref.description,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;

  var _useTranslations = (0,useTranslations/* useTranslations */.T)(),
      _useTranslations2 = (0,slicedToArray/* default */.Z)(_useTranslations, 1),
      translations = _useTranslations2[0];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    itemScope: true,
    itemProp: "author",
    className: className,
    itemType: "https://schema.org/Person",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionName, {
      children: translations['author/author']
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            type: "image/webp",
            srcSet: "".concat(image.url, "?w=120&fm=webp&q=80")
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            alt: name,
            loading: "lazy",
            src: "".concat(image.url, "?w=120&fm=jpg&q=80"),
            itemProp: "image",
            title: "".concat(name, " - ").concat(title)
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Info, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
          itemProp: "name",
          children: name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          itemProp: "jobTitle",
          children: title
        })]
      })]
    }), description && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
      itemProp: "description",
      children: description
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/styling/breakpoints.js
var breakpoints = __webpack_require__(39430);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Spacing.js
var Spacing = __webpack_require__(60348);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/Markdown/index.js + 31 modules
var Markdown = __webpack_require__(61118);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/constants/widths.js
var widths = __webpack_require__(78033);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/locales.js
var locales = __webpack_require__(81656);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/HeadMetaTags.js
var HeadMetaTags = __webpack_require__(96340);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/utilities/renderers.js
var renderers = __webpack_require__(96264);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/renderers/old-brand-renderer.js
var old_brand_renderer = __webpack_require__(97349);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/RichText.js
var RichText = __webpack_require__(17147);
;// CONCATENATED MODULE: ./lib/date.js
var addLeadingZeroes = function addLeadingZeroes(n) {
  return n <= 9 ? '0' + n.toString() : n.toString();
};

var formatDate = function formatDate(rawDate) {
  var date = new Date(rawDate);
  return "".concat(date.getFullYear(), "-").concat(addLeadingZeroes(date.getMonth() + 1), "-").concat(addLeadingZeroes(date.getDate()));
};
// EXTERNAL MODULE: ./main-hooks/index.js + 1 modules
var main_hooks = __webpack_require__(6112);
// EXTERNAL MODULE: ./constants/resources.js
var resources = __webpack_require__(42311);
// EXTERNAL MODULE: ./lib/renderers.js
var lib_renderers = __webpack_require__(8795);
// EXTERNAL MODULE: ./lib/locales.js
var lib_locales = __webpack_require__(12017);
// EXTERNAL MODULE: ./components/ResourceList.js
var ResourceList = __webpack_require__(84123);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(47041);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/HubspotForm/index.js + 2 modules
var HubspotForm = __webpack_require__(64094);
// EXTERNAL MODULE: ./node_modules/@trustpilot/businesssite-components/components/HeaderSubheader.js
var HeaderSubheader = __webpack_require__(88538);
;// CONCATENATED MODULE: ./components/GatedContent.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var GatedContent_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(Spacing/* Spacing */.Ki).withConfig({
  displayName: "GatedContent__Wrapper",
  componentId: "sc-1kjm9zu-0"
})(["background-color:", ";margin:", " 15px 60px;padding:46px 20px;text-align:center;position:relative;width:auto;", " @media (", "){margin:0 auto 80px auto;padding:108px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.greyLightest;
}, function (_ref2) {
  var hasFading = _ref2.hasFading;
  return hasFading ? '0' : '60px';
}, function (_ref3) {
  var hasFading = _ref3.hasFading;
  return hasFading ? "\n    &::before {\n      position: absolute;\n      width: 100%;\n      top: -400px;\n      left: 0;\n      background: linear-gradient(\n        to bottom,\n        rgba(255, 255, 255, 0) 0%,\n        rgba(255, 255, 255, 1) 75%\n      );\n      height: 400px;\n      content: '';\n      z-index: 99;\n    }\n  " : '';
}, breakpoints/* tablets */.Ye);
var GatedContent_Header = (0,styled_components_browser_esm/* default */.ZP)(HeaderSubheader/* HeaderSubheader */.R).withConfig({
  displayName: "GatedContent__Header",
  componentId: "sc-1kjm9zu-1"
})(["margin:0 auto 38px;"]);
var Text = (0,styled_components_browser_esm/* default */.ZP)(Markdown/* Markdown */.U).withConfig({
  displayName: "GatedContent__Text",
  componentId: "sc-1kjm9zu-2"
})(["margin:30px auto 0;text-align:center;"]);
var GATES_COOKIE = 'gates_passed';
var richTextModules = {
  resourceVideo: dynamic_default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 49085)).then(function (mod) {
      return mod.ResourceVideo;
    });
  }, {
    ssr: false,
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(49085)];
      }
    }
  }),
  resourceImage: dynamic_default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2774)).then(function (mod) {
      return mod.ResourceImageWithSpacing;
    });
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(2774)];
      }
    }
  }),
  pageHubspotForm: dynamic_default()(function () {
    return __webpack_require__.e(/* import() */ 1250).then(__webpack_require__.bind(__webpack_require__, 21250));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(21250)];
      }
    }
  }),
  emailSignup: dynamic_default()(function () {
    return __webpack_require__.e(/* import() */ 7216).then(__webpack_require__.bind(__webpack_require__, 97530));
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(97530)];
      }
    }
  })
};
var GatedContent = function GatedContent(props) {
  var slug = props.slug,
      form = props.form,
      hasFading = props.hasFading,
      children = props.children,
      gatedContent = props.gatedContent;

  var _ref4 = form || {},
      id = _ref4.id,
      headline = _ref4.headline,
      formComponent = _ref4.form,
      disclaimer = _ref4.disclaimer;

  var _useState = (0,react.useState)([]),
      gatesPassed = _useState[0],
      setGatesPassed = _useState[1];

  (0,react.useEffect)(function () {
    var gatesPassed = (0,lib.getCookie)(GATES_COOKIE);

    if (gatesPassed) {
      setGatesPassed(JSON.parse(gatesPassed));
    }
  }, []);
  var hasContent = children || gatedContent;
  var isGated = hasContent && gatesPassed.indexOf(slug) === -1;

  if (!isGated || !form) {
    if (gatedContent) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(RichText/* RichText */.Ho, {
        content: gatedContent,
        customModules: richTextModules
      });
    }

    return children || null;
  }

  var formCallback = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var newGates;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              newGates = [].concat((0,toConsumableArray/* default */.Z)(gatesPassed), [slug]);
              (0,lib.setCookies)(GATES_COOKIE, JSON.stringify(newGates), {
                maxAge: 900000,
                httpOnly: false,
                sameSite: 'strict'
              });
              setGatesPassed(function () {
                return newGates;
              });
              _context.next = 6;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 9000);
              });

            case 6:
              _context.next = 11;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              console.error(_context.t0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function formCallback() {
      return _ref5.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(GatedContent_Wrapper, {
    hasFading: hasFading,
    contentWidth: widths/* STANDARD_ARTICLE_WIDTH */.q4,
    id: id,
    children: [headline && /*#__PURE__*/(0,jsx_runtime.jsx)(GatedContent_Header, _objectSpread({
      centered: true
    }, headline)), /*#__PURE__*/(0,jsx_runtime.jsx)(HubspotForm/* DefaultHubspotForm */.AM, _objectSpread(_objectSpread({}, formComponent), {}, {
      submitCallback: formCallback
    })), disclaimer && /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
      children: disclaimer
    })]
  });
};
// EXTERNAL MODULE: ./components/ResourceSeoHeads.js
var ResourceSeoHeads = __webpack_require__(26813);
;// CONCATENATED MODULE: ./components/SingleResourceView.js



function SingleResourceView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SingleResourceView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SingleResourceView_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SingleResourceView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






























var TopPillarLink = (0,styled_components_browser_esm/* default */.ZP)(Links/* Link */.rU).withConfig({
  displayName: "SingleResourceView__TopPillarLink",
  componentId: "sc-1jrcm8m-0"
})(["display:block;text-align:center;margin-bottom:16px;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.blueSaturated;
});
var SingleResourceView_Title = (0,styled_components_browser_esm/* default */.ZP)(Headers.H1).withConfig({
  displayName: "SingleResourceView__Title",
  componentId: "sc-1jrcm8m-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme;
  return "\n    text-align: center;\n    margin-bottom: 24px;\n    font-size: ".concat(theme.fontSizes['2xl'], ";\n    line-height: ").concat(theme.leadings.xl, ";\n\n    @media (").concat(breakpoints/* tablets */.Ye, ") {\n      font-size: ").concat(theme.fontSizes['4xl'], ";\n      line-height: ").concat(theme.leadings['3xl'], ";\n    }\n  ");
});
var PublishedDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SingleResourceView__PublishedDate",
  componentId: "sc-1jrcm8m-2"
})(["text-align:center;color:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.greyDark;
});
var Introduction = (0,styled_components_browser_esm/* default */.ZP)(Markdown/* Markdown */.U).withConfig({
  displayName: "SingleResourceView__Introduction",
  componentId: "sc-1jrcm8m-3"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme;
  return "\n    padding: 0 15px;\n    margin: 0 auto 60px auto;\n    font-size: ".concat(theme.fontSizes.lg, ";\n    line-height: ").concat(theme.leadings.lg, ";\n    max-width: ").concat(theme.widths.standardArticle, "px;\n\n    @media (").concat(breakpoints/* tablets */.Ye, ") {\n      padding: 0 30px;\n      font-size: ").concat(theme.fontSizes.xl, ";\n      line-height: ").concat(theme.leadings.xl, ";\n    }\n  ");
});
var ArticleContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SingleResourceView__ArticleContent",
  componentId: "sc-1jrcm8m-4"
})(["content-visibility:auto;contain-intrinsic-size:1200px;", "{color:", ";}"], Links/* Link */.rU, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.blueSaturated;
});
var RelatedResourceHeader = (0,styled_components_browser_esm/* default */.ZP)(Headers.H3).withConfig({
  displayName: "SingleResourceView__RelatedResourceHeader",
  componentId: "sc-1jrcm8m-5"
})(["text-align:center;margin:0 0 48px 0;@media (", "){margin:0 0 70px 0;}"], breakpoints/* tablets */.Ye);
var ResourceFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SingleResourceView__ResourceFooter",
  componentId: "sc-1jrcm8m-6"
})(["margin-bottom:48px;border-width:1px 0;border-style:solid;border-color:", ";@media (", "){margin-bottom:106px;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyLight;
}, breakpoints/* tablets */.Ye);
var ResourceIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "SingleResourceView__ResourceIcon",
  componentId: "sc-1jrcm8m-7"
})(["width:120px;display:block;margin:0 auto 30px auto;"]);
var SocialIconsWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SingleResourceView__SocialIconsWrapper",
  componentId: "sc-1jrcm8m-8"
})(["width:100%;padding:18px 0 24px 0;border-width:1px 0 0 0;border-style:solid;border-color:", ";@media (", "){padding:18px 0 28px 0;}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.greyLight;
}, breakpoints/* tablets */.Ye);
var SingleResourceView_SectionName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SingleResourceView__SectionName",
  componentId: "sc-1jrcm8m-9"
})(["", ""], function (_ref8) {
  var theme = _ref8.theme;
  return "\n    font-weight: bold;\n    margin-bottom: 14px;\n    font-size: ".concat(theme.fontSizes.xs, ";\n    line-height: ").concat(theme.fontSizes.lg, ";\n  ");
});
var SocialIcons = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "SingleResourceView__SocialIcons",
  componentId: "sc-1jrcm8m-10"
})(["padding:0;list-style-type:none;"]);
var SocialShareIconItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "SingleResourceView__SocialShareIconItem",
  componentId: "sc-1jrcm8m-11"
})(["width:40px;height:40px;cursor:pointer;margin-right:10px;align-items:center;border-radius:30px;display:inline-flex;justify-content:center;background-color:", ";&:last-of-type{margin-right:0;}@media (", "){width:50px;height:50px;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.greyLightest;
}, breakpoints/* tablets */.Ye);
var SocialShareIconLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "SingleResourceView__SocialShareIconLink",
  componentId: "sc-1jrcm8m-12"
})(["width:100%;height:100%;display:inherit;align-items:inherit;justify-content:inherit;border-radius:inherit;& > svg{width:16px;height:16px;& > path{fill:#ffffff;}}"]);
var FacebookIconLinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(SocialShareIconLink).withConfig({
  displayName: "SingleResourceView__FacebookIconLinkWrapper",
  componentId: "sc-1jrcm8m-13"
})(["background-color:#4267b2;"]);
var TwitterIconLinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(SocialShareIconLink).withConfig({
  displayName: "SingleResourceView__TwitterIconLinkWrapper",
  componentId: "sc-1jrcm8m-14"
})(["background-color:#48aae6;"]);
var LinkedInIconLinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(SocialShareIconLink).withConfig({
  displayName: "SingleResourceView__LinkedInIconLinkWrapper",
  componentId: "sc-1jrcm8m-15"
})(["background-color:#0077b5;"]);
var HiddenData = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "SingleResourceView__HiddenData",
  componentId: "sc-1jrcm8m-16"
})(["display:none;"]);
var resourceModules = {
  resourceVideo: dynamic_default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 49085)).then(function (mod) {
      return mod.ResourceVideo;
    });
  }, {
    ssr: false,
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(49085)];
      }
    }
  }),
  resourceImage: dynamic_default()(function () {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 2774)).then(function (mod) {
      return mod.ResourceImageWithSpacing;
    });
  }, {
    loadableGenerated: {
      webpack: function webpack() {
        return [/*require.resolve*/(2774)];
      }
    }
  })
};
var renderResourcePageEntry = (0,renderers/* renderContentfulEntry */.A)(SingleResourceView_objectSpread(SingleResourceView_objectSpread({}, old_brand_renderer/* oldBrandComponents */.J), resourceModules));

var ResourceMetaTags = function ResourceMetaTags(_ref10) {
  var _resource$featuredRes, _resource$featuredRes2;

  var resource = _ref10.resource,
      resourceUrl = _ref10.resourceUrl,
      metaNoindex = _ref10.metaNoindex;

  var _useTranslations = (0,useTranslations/* useTranslations */.T)(),
      _useTranslations2 = (0,slicedToArray/* default */.Z)(_useTranslations, 1),
      translations = _useTranslations2[0];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(HeadMetaTags/* HeadMetaTags */.eU, {
    metaTitle: "".concat(resource.title ? "".concat(resource.title, " - ").concat(translations['meta/article/title']) : translations['meta/title']),
    metaDescription: resource.metaDescription || resource.intro || translations['meta/description'],
    metaNoindex: metaNoindex || resource.metaNoindex,
    metaOgUrl: resourceUrl ? resourceUrl : null,
    metaOgType: "article",
    metaOgImage: ((_resource$featuredRes = resource.featuredResource) === null || _resource$featuredRes === void 0 ? void 0 : (_resource$featuredRes2 = _resource$featuredRes.image) === null || _resource$featuredRes2 === void 0 ? void 0 : _resource$featuredRes2.url) || resource.thumbnail.url
  });
};

var RelatedResources = function RelatedResources(_ref11) {
  var relatedResources = _ref11.relatedResources;

  var _useTranslations3 = (0,useTranslations/* useTranslations */.T)(),
      _useTranslations4 = (0,slicedToArray/* default */.Z)(_useTranslations3, 1),
      translations = _useTranslations4[0];

  return relatedResources.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(RelatedResourceHeader, {
      children: translations['reviews/related']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacing/* Spacing */.Ki, {
      withXPadding: true,
      spaces: {
        bottom: 75
      },
      contentWidth: widths/* MAX_PAGE_WIDTH */.vf,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ResourceList/* ResourceList */.D, {
        resources: relatedResources.map(function (_ref12) {
          var slug = _ref12.slug,
              title = _ref12.title,
              thumbnail = _ref12.thumbnail,
              pillar = _ref12.pillar,
              industry = _ref12.industry;
          return {
            slug: slug,
            title: title,
            pillar: pillar,
            industry: industry,
            thumbnail: thumbnail
          };
        })
      })
    })]
  });
};
var BelowTheFoldContent = function BelowTheFoldContent(_ref13) {
  var resource = _ref13.resource;
  var btfContentCollection = resource.btfContentCollection;
  return btfContentCollection ? btfContentCollection === null || btfContentCollection === void 0 ? void 0 : btfContentCollection.items.map(lib_renderers/* renderContentBlock */.L) : '';
};
var SingleResourceArticle = function SingleResourceArticle(_ref14) {
  var _getLocaleByCode, _featuredResource$ima;

  var pillar = _ref14.pillar,
      industry = _ref14.industry,
      resource = _ref14.resource,
      resourceIcon = _ref14.resourceIcon;
  var slug = resource.slug,
      date = resource.date,
      title = resource.title,
      intro = resource.intro,
      author = resource.author,
      locale = resource.locale,
      content = resource.content,
      thumbnail = resource.thumbnail,
      hideFromPages = resource.hideFromPages,
      featuredResource = resource.featuredResource,
      _resource$sys = resource.sys,
      publishedAt = _resource$sys.publishedAt,
      firstPublishedAt = _resource$sys.firstPublishedAt;
  var resourceName = (0,main_hooks/* useResource */.W)();
  var resourceArea = industry ? industry : pillar;

  var _useTranslations5 = (0,useTranslations/* useTranslations */.T)(),
      _useTranslations6 = (0,slicedToArray/* default */.Z)(_useTranslations5, 2),
      translations = _useTranslations6[0],
      localeCode = _useTranslations6[1];

  var subdomain = (_getLocaleByCode = (0,locales/* getLocaleByCode */.KY)(localeCode)) === null || _getLocaleByCode === void 0 ? void 0 : _getLocaleByCode.subdomain;

  var createResourceUrl = function createResourceUrl(subdomain) {
    return "https://".concat(subdomain ? "".concat(subdomain, ".") : '', "business.trustpilot.com/").concat(resourceName, "/").concat(resourceArea, "/").concat(slug);
  };

  var inItsOwnLocale = lib_locales/* filteredEnglishLocales.find */.B.find(function (_ref15) {
    var code = _ref15.code;
    return code === localeCode;
  }) && locale === 'US' || locale === (0,locales/* getLocaleByCode */.KY)(localeCode).countryCode;

  var richTextModules = SingleResourceView_objectSpread(SingleResourceView_objectSpread({}, resourceModules), {}, {
    gatedContent: function gatedContent(props) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(GatedContent, SingleResourceView_objectSpread({
        form: props.gatedForm,
        hasFading: props.gatedFormHasFading !== false,
        slug: slug
      }, props));
    }
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ResourceMetaTags, {
      resource: resource,
      resourceUrl: createResourceUrl(subdomain),
      metaNoindex: !inItsOwnLocale || hideFromPages
    }), inItsOwnLocale && /*#__PURE__*/(0,jsx_runtime.jsx)(ResourceSeoHeads/* ResourceSeoHead */.Ro, {
      main: resourceName,
      pillar: resourceArea,
      resource: slug
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        itemProp: "dateCreated datePublished",
        content: formatDate(firstPublishedAt)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "pubdate",
        content: formatDate(firstPublishedAt)
      }), firstPublishedAt !== publishedAt && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "last_updated",
        content: formatDate(publishedAt)
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      itemScope: true,
      itemType: "http://schema.org/BlogPosting",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        itemScope: true,
        itemProp: "mainEntityOfPage",
        itemType: "https://schema.org/WebPage",
        itemID: createResourceUrl(subdomain)
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Spacing/* Spacing */.Ki, {
        withXPadding: true,
        contentWidth: 870,
        spaces: {
          top: 76,
          bottom: 40
        },
        children: [(resourceIcon === null || resourceIcon === void 0 ? void 0 : resourceIcon.url) && /*#__PURE__*/(0,jsx_runtime.jsx)(ResourceIcon, {
          src: resourceIcon.url,
          alt: resourceIcon.title,
          title: resourceIcon.description
        }), pillar && /*#__PURE__*/(0,jsx_runtime.jsx)(TopPillarLink, {
          href: "/".concat(resourceName, "/").concat(pillar),
          children: translations[resources/* pillarLabels */.o[pillar]]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SingleResourceView_Title, {
          centered: true,
          itemProp: "name headline",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PublishedDate, {
          itemProp: "dateCreated datePublished",
          children: new Date(date).toLocaleDateString(localeCode, {
            weekday: 'long',
            year: 'numeric',
            month: 'long',
            day: 'numeric'
          })
        }), firstPublishedAt !== publishedAt && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          itemProp: "dateModified",
          content: formatDate(publishedAt)
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        itemProp: "image",
        content: (featuredResource === null || featuredResource === void 0 ? void 0 : (_featuredResource$ima = featuredResource.image) === null || _featuredResource$ima === void 0 ? void 0 : _featuredResource$ima.url) || thumbnail.url
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ArticleContent, {
        children: [featuredResource && renderResourcePageEntry(featuredResource), intro && /*#__PURE__*/(0,jsx_runtime.jsx)(Introduction, {
          children: intro
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacing/* Spacing */.Ki, {
          withXPadding: true,
          spaces: [{
            bottom: 64
          }],
          contentWidth: widths/* STANDARD_ARTICLE_WIDTH */.q4,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(RichText/* RichText */.Ho, {
            content: content,
            customModules: richTextModules
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacing/* Spacing */.Ki, {
          withXPadding: true,
          contentWidth: widths/* STANDARD_ARTICLE_WIDTH */.q4,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ResourceFooter, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Author, SingleResourceView_objectSpread({}, author)), /*#__PURE__*/(0,jsx_runtime.jsxs)(HiddenData, {
              itemScope: true,
              itemProp: "publisher",
              itemType: "https://schema.org/Organization",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                itemScope: true,
                itemProp: "logo",
                itemType: "https://schema.org/ImageObject",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                  "aria-label": "trustpilot logo",
                  src: "https://cdn.trustpilot.net/brand-assets/2.0.0/favicons/favicon-dark-256x256.png"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
                  itemProp: "url",
                  content: "https://cdn.trustpilot.net/brand-assets/2.0.0/favicons/favicon-dark-256x256.png"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
                itemProp: "name",
                content: "Trustpilot"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SocialIconsWrapper, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SingleResourceView_SectionName, {
                children: translations['social/share']
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SocialIcons, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SocialShareIconItem, {
                  onClick: function onClick() {
                    return (0,tracking/* trackButtonClick */.kO)({
                      label: 'facebook',
                      location: 'share'
                    });
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(FacebookIconLinkWrapper, {
                    href: "https://www.facebook.com/sharer/sharer.php?u=".concat(createResourceUrl(subdomain)),
                    target: "_blank",
                    "aria-label": "Facebook share button",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* FacebookIcon */.Vq, {
                      title: "Facebook"
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialShareIconItem, {
                  onClick: function onClick() {
                    return (0,tracking/* trackButtonClick */.kO)({
                      label: 'twitter',
                      location: 'share'
                    });
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(TwitterIconLinkWrapper, {
                    href: "https://twitter.com/intent/tweet?status=".concat(encodeURIComponent(title), "+").concat(createResourceUrl(subdomain)),
                    target: "_blank",
                    "aria-label": "Twitter share button",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* TwitterIcon */.Zm, {
                      title: "Twitter"
                    })
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SocialShareIconItem, {
                  onClick: function onClick() {
                    return (0,tracking/* trackButtonClick */.kO)({
                      label: 'linkedin',
                      location: 'share'
                    });
                  },
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkedInIconLinkWrapper, {
                    href: "https://www.linkedin.com/shareArticle?mini=true&url=".concat(createResourceUrl(subdomain), "&title=").concat(encodeURIComponent(title)),
                    target: "_blank",
                    "aria-label": "Linkedin share button",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icons/* LinkedInIcon */.nI, {
                      title: "LinkedIn"
                    })
                  })
                })]
              })]
            })]
          })
        })]
      })]
    })]
  });
};

/***/ }),

/***/ 8795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ renderContentBlock; }
/* harmony export */ });
/* harmony import */ var _trustpilot_businesssite_components_utilities_renderers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96264);
/* harmony import */ var _trustpilot_businesssite_components_renderers_old_brand_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97349);


var renderContentBlock = (0,_trustpilot_businesssite_components_utilities_renderers__WEBPACK_IMPORTED_MODULE_0__/* .renderContentfulEntry */ .A)(_trustpilot_businesssite_components_renderers_old_brand_renderer__WEBPACK_IMPORTED_MODULE_1__/* .oldBrandComponents */ .J);

/***/ }),

/***/ 15458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ Box; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57247);


var Box = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Box",
  componentId: "sc-8par16-0"
})(["", " ", " ", " ", " ", " ", " ", " ", " ", ""], styled_system__WEBPACK_IMPORTED_MODULE_0__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .color */ .$_, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .flexbox */ .GQ, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .position */ .FK, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .typography */ .cp, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .border */ .Cg, styled_system__WEBPACK_IMPORTED_MODULE_0__/* .grid */ .eC, function (_ref) {
  var theme = _ref.theme,
      linkColor = _ref.linkColor;
  return linkColor ? "\n        a {\n          color: ".concat(theme.colors[linkColor], ";\n        }\n      ") : '';
});

/***/ }),

/***/ 88538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ HeaderSubheader; }
/* harmony export */ });
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styling_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39430);
/* harmony import */ var _Headers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1723);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["large", "header", "centered", "inverted", "subheader", "headerType", "className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var HeaderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "HeaderSubheader__HeaderWrapper",
  componentId: "sc-1g73br4-0"
})(["max-width:730px;margin:0 auto;"]);
var Subheader = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Headers__WEBPACK_IMPORTED_MODULE_2__.H4).withConfig({
  displayName: "HeaderSubheader__Subheader",
  componentId: "sc-1g73br4-1"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    opacity: 0.6;\n    font-size: ".concat(theme.fontSizes.sm, ";\n    line-height: ").concat(theme.leadings.md, ";\n  ");
});
var ContentBlockHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_Headers__WEBPACK_IMPORTED_MODULE_2__.H2).withConfig({
  displayName: "HeaderSubheader__ContentBlockHeader",
  componentId: "sc-1g73br4-2"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
      large = _ref2.large;
  return "\n    font-size: ".concat(theme.fontSizes['2xl'], ";\n    line-height: ").concat(theme.leadings.xl, ";\n\n      @media (").concat(_styling_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .tablets */ .Ye, ") {\n        font-size: ").concat(theme.fontSizes[large ? '3xl' : '2xl'], ";\n        line-height: ").concat(theme.leadings[large ? '2xl' : 'xl'], ";\n      }\n  ");
});
var HeaderSubheader = function HeaderSubheader(_ref3) {
  var large = _ref3.large,
      header = _ref3.header,
      centered = _ref3.centered,
      inverted = _ref3.inverted,
      subheader = _ref3.subheader,
      headerType = _ref3.headerType,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className,
      props = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref3, _excluded);

  var HeaderComponent;

  switch (headerType) {
    case 'Page Header':
      HeaderComponent = _Headers__WEBPACK_IMPORTED_MODULE_2__.H1;
      break;

    case 'Content Block Header':
      HeaderComponent = ContentBlockHeader;
      break;

    default:
      HeaderComponent = ContentBlockHeader;
  }

  var subHeadComponent = /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(Subheader, {
    regularWeight: true,
    noSpacing: !inverted,
    centered: centered,
    children: subheader
  });

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(HeaderWrapper, _objectSpread(_objectSpread({
    className: className
  }, props), {}, {
    children: [inverted && subheader && subHeadComponent, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(HeaderComponent, {
      large: large,
      centered: centered,
      noSpacing: inverted || !subheader,
      children: header
    }), !inverted && subheader && subHeadComponent]
  }));
};

/***/ }),

/***/ 95641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _Links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17221);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);



var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_Links__WEBPACK_IMPORTED_MODULE_0__/* .Link */ .rU).withConfig({
  displayName: "NewBrandButtons__Button",
  componentId: "sc-1ny1mra-0"
})(["", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme,
      _ref$$uiType = _ref.$uiType,
      $uiType = _ref$$uiType === void 0 ? 'outline' : _ref$$uiType,
      $colorVariant = _ref.$colorVariant,
      wide = _ref.wide;
  var basePadding = wide ? '12px 100px' : '12px 32px';
  var baseStyles = "\n      display: inline-block;\n      border: none;\n      text-align: center;\n      padding: ".concat(basePadding, ";\n      border-radius: 99px;\n      cursor: pointer;\n      transform: translate3d(0,0,0);\n      transition: box-shadow 150ms linear, background-color 150ms linear;\n    ");
  var typeStyles = $uiType === 'solid' ? "\n          color: ".concat(theme.buttons[$uiType][$colorVariant].color, "};\n          background-color: ").concat(theme.buttons[$uiType][$colorVariant].bgColor, ";\n\n          &:hover {\n            background-color: ").concat(theme.buttons[$uiType][$colorVariant].hoverBgColor, ";\n          }\n\n          &:active {\n            background-color: ").concat(theme.buttons[$uiType][$colorVariant].activeBgColor, ";\n          }\n        ") : "\n          box-shadow: 0 0 0 1px ".concat(theme.buttons[$uiType][$colorVariant].borderColor, ";\n          color: ").concat(theme.buttons[$uiType][$colorVariant].color, ";\n          font-weight: ").concat(theme.buttons[$uiType][$colorVariant].fontWeight, ";\n\n          &:hover, &:focus-visible {\n            color: ").concat(theme.buttons[$uiType][$colorVariant].hoverColor, ";\n            background-color: ").concat(theme.buttons[$uiType][$colorVariant].hoverBgColor, ";\n            box-shadow: 0 0 0 3px ").concat(theme.buttons[$uiType][$colorVariant].hoverBorderColor, ";\n          }\n\n          &:active {\n            color: ").concat(theme.buttons[$uiType][$colorVariant].activeColor, ";\n            background-color: ").concat(theme.buttons[$uiType][$colorVariant].activeBgColor, ";\n            box-shadow: 0 0 0 3px ").concat(theme.buttons[$uiType][$colorVariant].activeBorderColor, ";\n          }\n        ");
  return "\n      ".concat(baseStyles, "\n      ").concat(typeStyles, "\n      font-size: ").concat(theme.fontSizes.xs, ";\n      ");
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .layout */ .bK, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .typography */ .cp);

/***/ })

}]);